import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import finnHub from "../apis/finnHub"
import StockChart from "../components/StockChart"

function formatData(data) {
  return data.t.map((el, index) => {
    return {
      x: el * 1000,
      y: Math.floor(data.c[index])
    }
  })
}

export default function StockDetailPage() {

  // "{ symbol }" comes from ":symbol" in
  // <Route path='/detail/:symbol' element={<StockDetailPage />}/>
  // in the routes in App.js
  const { symbol } = useParams()
  const [chartData, setChartData] = useState()

  useEffect(() => {
    async function fetchData() {
      const date = new Date()
      const currentTime = Math.floor(date.getTime()/1000)
      const oneWeek = 7 * 24 * 60 * 60
      const oneYear = 365 * 24 * 60 * 60
      let oneDay
      if (date.getDay() === 6) {
        oneDay = currentTime - 2 * 24 * 60 * 60
      } else if (date.getDay() === 0) {
        oneDay = currentTime - 3 * 24 * 60 * 60
      } else {
        oneDay = currentTime - 24 * 60 * 60
      }
      try {
        const responses = await Promise.all([
          finnHub.get('/stock/candle', {
            params: {
              symbol,
              from: oneDay,
              to: currentTime,
              resolution: 30
            }
          }),
          finnHub.get('/stock/candle', {
            params: {
              symbol,
              from: oneWeek,
              to: currentTime,
              resolution: 60
            }
          }),
          finnHub.get('/stock/candle', {
            params: {
              symbol,
              from: oneYear,
              to: currentTime,
              resolution: 'W'
            }
          })
        ])
        console.log(responses)
        setChartData({
          day: formatData(responses[0].data),
          week: formatData(responses[1].data),
          year: formatData(responses[2].data)
        })
      } catch(err) {
        console.log(err)
      }
    }
    fetchData()
  }, [symbol])
 
  return (
    <div>{chartData && (<div><StockChart chartData={chartData} symbol={symbol} /></div>)}</div>
  )
}
